import { useState } from 'react';
import { useMutation, useQuery } from 'convex/react';
import { Link } from 'react-router-dom';
import { api } from '../../../../convex/_generated/api';

export default function Clients() {
  const clients = useQuery(api.clients.list, {});
  const create = useMutation(api.clients.create);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);

  async function add() {
    if (!name.trim()) return;
    setBusy(true);
    try {
      await create({
        name: name.trim(),
        ...(email.trim() ? { billingEmail: email.trim() } : {}),
        ...(phone.trim() ? { billingPhone: phone.trim() } : {}),
      });
      setName(''); setEmail(''); setPhone('');
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <h1>Clients</h1>

      <div className="card">
        <strong>Add a client</strong>
        <label>Name</label>
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Bunnings Malaga" />
        <label>Billing email</label>
        <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="whs@client.com.au" />
        <label>Mobile</label>
        <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+61400000000" />
        <p className="muted small">
          Reminders go to the email if there is one, otherwise the mobile. A client with neither
          is skipped when reminders are drafted.
        </p>
        <button disabled={busy || !name.trim()} onClick={() => void add()}>Add client</button>
      </div>

      <div className="card">
        <table>
          <thead><tr><th>Client</th><th>Contact</th><th>Portal slug</th></tr></thead>
          <tbody>
            {(clients ?? []).map((c) => (
              <tr key={c._id}>
                <td><Link to={`/clients/${c._id}`}>{c.name}</Link></td>
                <td className="muted">{c.billingEmail ?? c.billingPhone ?? '— none —'}</td>
                <td className="muted small">{c.portalSlug}</td>
              </tr>
            ))}
            {clients?.length === 0 ? (
              <tr><td colSpan={3} className="muted">No clients yet.</td></tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </>
  );
}
